var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.456 8.09H16.57V5.86c0-.76-.62-1.37-1.37-1.37H3.65c-.75 0-1.36.61-1.36 1.37v8c0 .75.61 1.37 1.36 1.37h1.81v2.76c0 .24.14.46.37.55.07.03.15.05.23.05.15 0 .3-.06.42-.18l3.19-3.18h.706v.927c0 .692.562 1.255 1.254 1.255h4.665l2.693 2.682a.602.602 0 00.654.13.6.6 0 00.37-.554v-2.258h1.444c.692 0 1.254-.563 1.254-1.255V9.344c0-.692-.562-1.255-1.254-1.255zM9.419 14.03c-.15 0-.31.06-.42.17l-2.34 2.34v-1.91c0-.33-.27-.6-.6-.6H3.65c-.09 0-.17-.08-.17-.17v-8c0-.1.08-.17.17-.17H15.2c.09 0 .17.07.17.17v2.23H11.63c-.692 0-1.255.562-1.255 1.254v4.685H9.42zm12.037 2.182h-2.044a.6.6 0 00-.6.6v1.413l-1.845-1.838a.6.6 0 00-.423-.175H11.63l-.055-.055.055-6.868 9.881.055-.055 6.868z"
  })));
}

export default SvgSpeech;